<template>
    <div  :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="ListIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
    </div>
</template>

<script>
    export default {
        name: 'CellRendererActions',
        methods: {
          editRecord() {
            this.$router.push("/application/candidat/presance/" + this.params.data.id+"/"+this.params.data.classe_id).catch(() => {})
          },
          
        }
    }
</script>
